export const buildMediaProxyUrl = (url?: string | null): string | null => {
  const trimmedUrl = url?.trim();

  if (!trimmedUrl) {
    return null;
  }

  if (trimmedUrl.startsWith('/api/media/proxy')) {
    return trimmedUrl;
  }

  if (trimmedUrl.startsWith('/')) {
    return trimmedUrl;
  }

  return `/api/media/proxy?url=${encodeURIComponent(trimmedUrl)}`;
};
